import React from 'react';

import ReactDOM from 'react-dom';
import RecommendationCreator from './RecommendationCreator';
import {
  localization,
  SurveyQuestionEditorDefinition,
} from 'survey-creator-react';
import { ElementFactory, Question, Serializer } from 'survey-core';
import {
  SurveyQuestionElementBase,
  ReactQuestionFactory,
} from 'survey-react-ui';

export const ReportRecommendations = {
  render: function (editor: any, htmlElement: any) {
    const isDOM = htmlElement instanceof Element;

    if (isDOM) {
      ReactDOM.render(
        <RecommendationCreator
          value={editor.editingValue}
          saveValue={(value: any) => editor.koValue(value)}
          editor={editor}
        />,
        htmlElement
      );
    }
  },
};

// create model for new question type
export class QuestionReportRecommendationsModel extends Question {
  getType() {
    return 'reportRecommendations';
  }
  get reportRecommendationsType() {
    return this.getPropertyValue('reportRecommendations');
  }
  set reportRecommendationsType(val) {
    this.setPropertyValue('reportRecommendations', val);
  }
}

// set display title for question type
localization.getLocale('').qt.reportRecommendations = 'Report Recommendations';

// this serializes the class into JSON
Serializer.addClass(
  'reportRecommendations',
  [
    {
      name: 'reportRecommendationsType',
    },
  ],
  function () {
    return new QuestionReportRecommendationsModel('');
  },
  'question'
);

SurveyQuestionEditorDefinition.definition.reportRecommendations = {
  properties: [{ name: 'reportRecommendationsType', tab: 'layout' }],
};

// register question with its model
export function registerReportRecommendations() {
  ElementFactory.Instance.registerElement(
    'reportRecommendations',
    (name: string) => {
      return new QuestionReportRecommendationsModel(name);
    }
  );
}

export class SurveyQuestionReportRecommendations extends SurveyQuestionElementBase {
  constructor(props: any) {
    super(props);

    this.state = {
      value: this.question.value,
    };
  }
  get question() {
    return this.questionBase;
  }
  get value() {
    return this.question.value;
  }

  get type() {
    // @ts-ignore
    return this.question.reportRecommendationsType;
  }
  handleReportRecommendationsChange = (data: any) => {
    this.question.value = data;
    this.setState({ value: data });
  };

  // support readOnly and designMode
  get style() {
    return this.question.getPropertyValue('readOnly') ||
      this.question.isDesignMode
      ? {
          pointerEvents: 'none',
        }
      : undefined;
  }

  renderElement() {
    return (
      <RecommendationCreator
        value={this.state.value}
        saveValue={this.handleReportRecommendationsChange}
        editor={this.question}
      />
    );
  }
}

ReactQuestionFactory.Instance.registerQuestion(
  'reportRecommendations',
  (props: any) => {
    return React.createElement(SurveyQuestionReportRecommendations, props);
  }
);
